<template>
  <div class="w-full">
    <Modal :title="$t('Preview')" v-model="props.isModal" containerClass="w-2/5 max-w-[600px]  p-2">
      <template #closeIcon>
        <button @click="onClose"><faTimes class="w-4" /></button>
      </template>
      <template #bodyContent>
        <div class="flex flex-col">
          <img :src="previewSrc" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script setup>
import Modal from '@/components/Ui/Modal/index.vue'
import faTimes from '@/assets/icons/faTimes.svg?component'

const emits = defineEmits(['onClose', 'confirm'])
const props = defineProps({
  isModal: {
    type: Boolean,
    default: () => false
  },
  previewSrc: Object
})

const onClose = () => {
  emits('onClose')
}
</script>
<script>
export default {
  name: 'PreviewModal'
}
</script>
